import { render, staticRenderFns } from "./searchNews.vue?vue&type=template&id=6ed29e58&scoped=true&"
import script from "./searchNews.vue?vue&type=script&lang=js&"
export * from "./searchNews.vue?vue&type=script&lang=js&"
import style0 from "./searchNews.vue?vue&type=style&index=0&id=6ed29e58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed29e58",
  null
  
)

export default component.exports